import { apiRequest } from './core/client';

/**
 * Run now / Work this with Claude (plan W9). The orders server queues the
 * request and the Mac's dispatcher starts the session within seconds while the
 * Mac is awake; anything queued while it sleeps starts on wake.
 */
export type RunSubject = { orderId: string } | { setupFolder: string } | { actionId: string };

export interface RunRequest {
  id: string;
  kind: 'drain' | 'work_session' | 'desk_session';
  reason: string;
  requestedAt: string | null;
  claimedAt: string | null;
  runSessionId: string | null;
  finishedAt: string | null;
  outcome: 'ok' | 'partial' | 'failed' | 'skipped' | 'cancelled' | null;
  outcomeNote: string | null;
}

function subjectFields(s: RunSubject): Record<string, string> {
  if ('actionId' in s) return { action_id: s.actionId };
  if ('setupFolder' in s) return { setup_folder: s.setupFolder };
  return { order_id: s.orderId };
}

export async function queueRun(kind: 'drain' | 'work_session', subject: RunSubject): Promise<{ request: RunRequest; joined: boolean }> {
  return apiRequest({ path: '/orders/run-requests', method: 'POST', body: { kind, ...subjectFields(subject) } });
}

export async function latestRuns(subject: RunSubject): Promise<{ drain: RunRequest | null; work_session: RunRequest | null }> {
  return apiRequest({ path: '/orders/run-requests/latest', method: 'GET', query: subjectFields(subject) });
}

/** The desk session (plan W13): attended, no subject, one at a time. */
export async function queueDesk(): Promise<{ request: RunRequest; joined: boolean }> {
  return apiRequest({ path: '/orders/run-requests', method: 'POST', body: { kind: 'desk_session' } });
}

export async function latestDesk(): Promise<{ desk_session: RunRequest | null }> {
  return apiRequest({ path: '/orders/run-requests/latest', method: 'GET', query: { kind: 'desk_session' } });
}
